import React, { Component } from 'react'
import { Col, Row } from 'antd'
import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()

export default class InfoClient extends Component {
  render() {
    const { t, order, infoClient, configClient } = this.props
    const filename = configClient && configClient.imageFileName ? configClient.imageFileName : null
    const urlImg = `${publicRuntimeConfig.logoImagesBasePath}${filename}`

    return (
      (infoClient && (
        <Row>
          <Col span={20}>
            <Row>
              <Col>
                <h4 className='content-title'>{t('Client')}</h4>
              </Col>
            </Row>
            <Row>
              <Col span={6}>
                <span>{t('Name')}</span>
              </Col>
              <Col span={6}>
                <b>{infoClient.nombre}</b>
              </Col>
            </Row>
            <Row>
              <Col span={6}>
                <span>{t('Email')}</span>
              </Col>
              <Col span={15}>
                <b> {infoClient.email}</b>
              </Col>
            </Row>
            <Row>
              <Col span={6}>
                <span>{t('Phone')}</span>
              </Col>
              <Col span={15}>
                <b>{infoClient.telefono}</b>
              </Col>
            </Row>
            <Row>
              <Col span={6}>
                <span>{t('Address')}</span>
              </Col>
              <Col span={15}>
                <b>{infoClient.domicilio}</b>
              </Col>
            </Row>
            <Row>
              <Col span={6}>
                <span>{t('Location')}</span>
              </Col>
              <Col span={15}>
                <b>{infoClient.nombrelocalidad}</b>
              </Col>
            </Row>
            <Row>
              <Col span={6}>
                <span>{t('Province')}</span>
              </Col>
              <Col span={15}>
                <b>{infoClient.nombreprovincia}</b>
              </Col>
            </Row>
          </Col>
          {filename && (
            <Col span={4} style={{ paddingTop: '20px' }}>
              <img width={'50%'} src={urlImg} />
            </Col>
          )}
        </Row>
      )) ||
      null
    )
  }
}
